var L = /* @__PURE__ */ ((l) => (l.SMALL = "small", l.MEDIUM = "medium", l.LARGE = "large", l.DEFAULT = "default", l))(L || {});
export {
  L as BrandIconSize
};
//# sourceMappingURL=BrandIconSize.type.mjs.map
